import BaseFormPage from "../../../../base/BaseFormPage.js";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object/index.js";
import withRouter from "../../../../withRouter.js";
import DialogSuccess from "../../../../components/DialogSuccess/index.js";
import dialog from "../../../../components/Modal/dialog.js";
import FullPageLoader from "../../../../components/FullPageLoader/index.js";
import CustomLoader from "../../../../components/CustomLoader/index.js";
import { InfiniteScroll } from "../../../../nq-component";
import ReceiptsTable from "../components/ReceiptsTable/index.js";
import CustomConfirmation from "../../../../components/CustomConfirmation/index.js";
import FormDialog from "../components/FormDialog/index.js";
import { addReceipt } from "../../../../dexie/addReceipt.js";
import BySupplierFormPagePresenter from "./BySupplierFormPagePresenter.js";
import FormPage from "../components/FormPage.js";
import ActionButtons from "../components/ActionButtons.js";
import CollapseDetails from "../components/CollapseDetails.js";
import PreviewModal from "../components/PreviewModal/index.js";
import AddButton from "../../../../components/AddButton/index.js";
import PageHeader from "../../../../components/PageHeader/index.js";

class BySupplierFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      objects: [],
      banks: [],
      receipts: [],
      pageProgress: false,
      date: null,
      supplier: "",
      isModalOpen: false,
    };
    this.presenter = new BySupplierFormPagePresenter(
      this,
      getObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      findObjectUseCase(),
    );
  }

  getCollectionName() {
    return "purchases";
  }

  getParamsMonth() {
    return this.props.params.month;
  }

  getParamsYear() {
    return this.props.params.year;
  }

  getClientId() {
    return this.props.params.clientId;
  }

  getIndexedDB() {
    return "purchasesBySupplier";
  }

  onClose() {
    dialog.close();
  }

  successModal(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  onSaveForm(object) {
    addReceipt(object);
  }

  onDelete(id) {
    this.presenter.onDelete(id);
  }

  onDeleteModal(objectId) {
    dialog.fire({
      html: <CustomConfirmation onConfirm={() => this.onDelete(objectId)} />,
      footer: false,
    });
  }

  onSubmit() {
    this.presenter.submitAllReceipts();
  }

  submitConfirmation() {
    dialog.fire({
      html: (
        <CustomConfirmation
          message={"Are you sure you want to submit all entries?"}
          onConfirm={this.onSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  receiptModal(object) {
    const { banks, receipts, supplier } = this.state;
    const schemas = this.getSchemas();
    const schema = this.getSchema(this.getCollectionName());
    const clientId = this.getClientId();
    const user = this.getCurrentUser();
    const collection = this.getIndexedDB();

    dialog.fire({
      html: (
        <FormDialog
          // onSubmit={this.addReceipt.bind(this)}
          supplier={supplier}
          object={object || null}
          receipts={receipts}
          setState={this.setState.bind(this)}
          banks={banks}
          schema={schema}
          schemas={schemas}
          collection={collection}
          where={{
            $or: [
              { creator: { id: user.id } },
              { client: { id: user.client?.id } },
            ],
          }}
        />
      ),
      footer: false,
      size: "lg",
    });
  }

  onCollapse(index, object) {
    return (
      <CollapseDetails
        object={object}
        onDelete={this.onDeleteModal.bind(this)}
        onEdit={this.receiptModal.bind(this)}
      />
    );
  }

  showPageProgress() {
    this.setState({ pageProgress: true });
  }

  hidePageProgress() {
    this.setState({ pageProgress: false });
  }

  toggleModal() {
    this.setState((prevState) => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen,
    }));
  }

  onChangeFormPage(value, field) {
    if (field === "supplier") {
      this.presenter.getAllreceipts(value);
    }
    this.setState({ [field]: value });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const {
      progress,
      count,
      selected,
      receipts,
      pageProgress,
      supplier,
      date,
      isModalOpen,
    } = this.state;
    const user = this.getCurrentUser();
    const clientId = this.getClientId();

    const month = this.getParamsMonth();
    const year = this.getParamsYear();
    const paddedMonth = String(month).padStart(2, "0");
    const lastDay = new Date(year, month, 0).getDate();

    const minDate = `${year}-${paddedMonth}-01`;
    const maxDate = `${year}-${paddedMonth}-${String(lastDay).padStart(
      2,
      "0",
    )}`;
    return (
      <>
        <InfiniteScroll
          className="p-3 p-xl-4 overflow-auto"
          // loadMore={this.loadMore.bind(this)}
          hasMore={!progress && count > receipts.length}
        >
          <div className="d-flex flex-column gap-3">
            <PageHeader
              breadcrumb={[
                { label: "Home", path: "/" },
                { label: "Purchases", path: "/purchases" },
                { label: "Add Purchases" },
              ]}
              title={"Add Purchases"}
              backButton
              description={
                "All outgoing transactions related to expenses and purchases."
              }
            />

            <FormPage
              schema={schema}
              schemas={schemas}
              minDate={minDate}
              maxDate={maxDate}
              objects={receipts}
              onChange={this.onChangeFormPage.bind(this)}
              where={{
                $and: [
                  { client: { id: clientId || user.client?.id } },
                  { isActive: true },
                ],
              }}
            />
            <PreviewModal
              isModalOpen={isModalOpen}
              objects={receipts}
              toggleModal={this.toggleModal.bind(this)}
              onEdit={this.receiptModal.bind(this)}
              onDelete={this.onDeleteModal.bind(this)}
              isMobile={this.isMobile.bind(this)}
              saveObjects={this.submitConfirmation.bind(this)}
            />
            {progress ? (
              <CustomLoader />
            ) : (
              <ReceiptsTable
                supplier={supplier}
                objects={receipts}
                schema={schema}
                schemas={schemas}
                selected={selected}
                onDelete={this.onDeleteModal.bind(this)}
                onEdit={this.receiptModal.bind(this)}
                showProgress={this.showProgress.bind(this)}
                hideProgress={this.hideProgress.bind(this)}
                excludeFields={["date", "supplier"]}
              />
            )}
          </div>
          {receipts && receipts.length !== 0 ? (
            <ActionButtons
              disabled={!date}
              onSubmit={this.toggleModal.bind(this)}
            />
          ) : (
            ""
          )}
          <AddButton
            toolTip={true}
            toolMessage={"Please choose a supplier first before adding."}
            onClick={
              supplier && Object.keys(supplier).length > 0
                ? () => this.receiptModal()
                : null
            }
            show={true}
          />
        </InfiniteScroll>
        {pageProgress && <FullPageLoader />}
        {this.renderPreviewModal()}
      </>
    );
  }
}

export default withRouter(BySupplierFormPage);
